import {  Component} from '@angular/core';
import {
  ChatThreadClient,
  ChatThreadItem,
} from '@azure/communication-chat';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/app/User/Service/user.service';
import { ChatService } from './chat.service';
import { Subscription, lastValueFrom } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { formatInTimeZone } from 'date-fns-tz';

const toUtcDate = (d: unknown): Date => {
  if (d instanceof Date) return d;
  const s = String(d);
  return new Date(/[Z]|[+-]\d{2}:?\d{2}$/.test(s) ? s : s + 'Z');
};

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.css'],
    standalone: false
})
export class ChatComponent {
  currentThread: ChatThreadItem = {} as ChatThreadItem;
  chatThreadClient: ChatThreadClient | any = null;
  messages = [];
  message = '';
  typingMessage = '';
  activeUrl: boolean;
  searchInput:string='';
  subscription = new Subscription();
  constructor(
    public http: HttpClient,
    private route: ActivatedRoute,
    public userService: UserService,
    public chatService: ChatService
  ) { }
  async ngOnInit(): Promise<void> {

    this.activeUrl = document.URL.includes('authprofessional/chat');
    const params = lastValueFrom(this.route.params);
    this.currentThread = params['id'];
    await this.chatService.getAllThreads();
    if (!this.currentThread)
      this.currentThread = this.chatService.allThreats[0];
    this.updateThread(this.currentThread);
    this.setupHandlers();
    this.subscription.add(
      this.chatService.newMessage$.subscribe((data) => {
        this.getListMessages(data);
      })
    );
  }
  async getAllReadMessages() {
    const listReadReceipts = this.chatThreadClient.listReadReceipts();
    for await (const message of listReadReceipts) {
      console.log(message);
    }
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async setupHandlers() {
    this.chatService.chatClient.on(
      'typingIndicatorReceived',
      ((state: any) => {
        if (
          state.sender.communicationUserId !=
          this.userService.userInfo.acsIdentity
        ) {
          this.typingMessage = state.senderDisplayName;
          setTimeout(() => {
            this.typingMessage = '';
          }, 7000);
        }
      }).bind(this)
    );

    this.chatService.chatClient.on(
      'chatMessageEdited',
      ((state: any) => {
        this.getListMessages(state);
      }).bind(this)
    );
    this.chatService.chatClient.on(
      'chatMessageDeleted',
      ((state: any) => {
        this.getListMessages(state);
      }).bind(this)
    );
    this.chatService.chatClient.on(
      'chatThreadDeleted',
      (async (state: any) => {
        await this.chatService.getAllThreads(true);
        this.updateThread(this.chatService.allThreats[0]);
      }).bind(this)
    );
  }
  async getListMessages(state) {
    console.log(state);
    if (state.threadId === this.currentThread.id) this.updateMessages();
  }
  async updateMessages() {
    this.messages = [];
    const messages = this.chatThreadClient.listMessages();
    for await (const message of messages) {
      if (message.type == 'text' && !message.deletedOn)
        this.messages.push(message);
    }
    console.log(this.messages);
  }
  async updateThread(thread) {
    console.log(thread);
    this.currentThread = thread;
    this.chatThreadClient = this.chatService.chatClient.getChatThreadClient(
      thread.id
    );
    this.updateMessages();
  }
  async readMessage(id) {
    const resp = await this.chatThreadClient.sendReadReceipt({
      chatMessageId: id,
    });
    console.log(resp);
  }
  async sendMessage() {
    await this.chatThreadClient.sendMessage(
      {
        content: this.message,
      },
      {
        senderDisplayName: this.userService.fullName,
        type: 'text',
      }
    );
    this.message = '';
  }
  async sendTypingNotification() {
    await this.chatThreadClient.sendTypingNotification({
      senderDisplayName:
        this.userService.userInfo?.firstName +
        ' ' +
        this.userService.userInfo?.lastName +
        ' is typing ....',
    });
  }
  async deleteMessage(id) {
    await this.chatThreadClient.deleteMessage(id);
  }
  async deleteChatThread(id) {
    await this.chatService.chatClient.deleteChatThread(id);
  }
  searchThread() {
    return this.chatService.allThreats.filter(thread =>
      thread.topic.toLowerCase().includes(this.searchInput.toLowerCase())
    );
  }

  getConvertedDate(date: any) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return formatInTimeZone(toUtcDate(date), userTimeZone, 'dd MMM yyyy, h:mm a');
  }
  getName(name:string){
    const fName = name.split(" ")[0];
    const lName = name.split(" ")[1];
    return (fName[0]+lName[0]).toUpperCase();
  }
}
